// Official company accounts. Keep personal profiles out of brand navigation.
export const socialLinks = [
  { label: "Instagram", icon: "instagram", href: "https://www.instagram.com/kedbyteofficial/" },
  { label: "LinkedIn", icon: "linkedin", href: "https://www.linkedin.com/company/kedbyte/" },
  { label: "X (Twitter)", icon: "x", href: "https://x.com/kedbyte" },
];
